import { IProduct } from 'models';
import { IApplicationState } from './reducers/rootReducer';

export const getProducts = (state: IApplicationState) => {
  return state.appReducer.applicationRoot.products;
};

export const getApplications = (state: IApplicationState) => {
  return state.appReducer.applicationRoot.applications;
};

export const getTechData = (state: IApplicationState) => {
  return state.appReducer.applicationRoot.applications;
};

export const getStep = (state: IApplicationState) => {
  if (!state.appReducer.application) return null;
  return state.appReducer.application.steps[state.appReducer.stepIndex];
};

const matchesMandatoryFilters = (inputs: Map<string, string>, product: IProduct) => {
  const optionalInputRating = 'Rating';
  let matches = true;
  for (const [key, value] of inputs.entries()) {
    if (value.includes(',')) {
      const lower = parseInt(value.substring(0, value.indexOf(',')));
      const upper = parseInt(value.substring(value.indexOf(',') + 1));

      const valueIsBetween = (value: number): boolean => {
        return value >= lower && value <= upper;
      };

      if (!product.metadata.some((data) => data.key === key && valueIsBetween(parseInt(data.value)))) {
        matches = false;
      }

      continue;
    }

    // Ignore 'Rating' - optional input
    if (key === optionalInputRating) {
      continue;
    } else if (!product.metadata.some((data) => data.key === key && data.value === value)) {
      matches = false;
    }
  }
  return matches;
};

const matchesOptionalFilter = (key: string, inputs: Map<string, string>, product: IProduct) => {
  const value = inputs.get(key);

  if (product.metadata.some(((data) => data.key === key && data.value === value))
    && matchesMandatoryFilters(inputs, product)) {
    return true;
  } else if (product.metadata.some(((data) => data.key === key && data.value !== value))) {
    return false;
  }

  return null;
};

export const getFilteredProducts = (state: IApplicationState) => {
  const { inputs, applicationRoot } = state.appReducer;
  const { products } = applicationRoot;
  const optionalInputRating = 'Rating';

  return products.filter((product) => {
    let matchesFiltering = matchesMandatoryFilters(inputs, product);

    if (inputs.get(optionalInputRating)) {
      const matchesRating = matchesOptionalFilter(optionalInputRating, inputs, product);
      matchesFiltering = matchesRating != null ? matchesRating : matchesFiltering;
    }
    return matchesFiltering;
  });
};
